export {
  SurveyFieldOptions,
  SurveyFieldOption,
  GenerateSurveyFieldOptionValue,
  MAX_SURVEY_FIELDS,
  MIN_SURVEY_FIELD_OPTIONS,
  MAX_SURVEY_FIELD_OPTIONS,
} from "./SurveyFieldOptions";

export {
  FAST_POLL_MIN_CHOICES,
  FAST_POLL_MAX_CHOICES,
  FAST_POLL_OTHER_VALUE,
  FEATURE_PRIORITY_MIN_ITEMS,
  FEATURE_PRIORITY_MAX_ITEMS,
  USER_CHOICE_MIN_VARIANTS,
  USER_CHOICE_MAX_VARIANTS,
  GetUserChoiceAttributeLimits,
} from "./SurveyOptionLimits";

export {
  ProductTypes,
  ServiceTypes,
  ProductIndustries,
  ServiceIndustries,
} from "./ProductServiceOptions";

export { CurrencyOptions } from "./CurrencyOptions";

/**
 * Environment detection utility for frontend
 * Determines if the application is running in development or production
 */
const getRuntimeHostname = (): string => {
  if (typeof window !== "undefined" && window.location?.hostname) {
    return window.location.hostname;
  }

  if (typeof document !== "undefined" && typeof document.domain === "string") {
    return document.domain;
  }

  return "";
};

const Environment = {
  isDev: () => {
    const hostname = getRuntimeHostname();
    return hostname === "localhost" || hostname.includes("127.0.0.1") || hostname.includes("dev");
  },
  isProd: () => !Environment.isDev(),
  getEnv: () => (Environment.isDev() ? "development" : "production"),
};

/**
 * Frontend console logger with environment awareness
 * Only outputs to console in development environment
 */
export const FrontendLogger = {
  debug: (message: string, ...args: any[]) => {
    if (Environment.isDev()) {
      console.log(`[DEV-DEBUG] ${message}`, ...args);
    }
  },
  info: (message: string, ...args: any[]) => {
    if (Environment.isDev()) {
      console.log(`[DEV-INFO] ${message}`, ...args);
    }
  },
  warn: (message: string, ...args: any[]) => {
    if (Environment.isDev()) {
      console.warn(`[DEV-WARN] ${message}`, ...args);
    }
  },
  error: (message: string, ...args: any[]) => {
    if (Environment.isDev()) {
      console.error(`[DEV-ERROR] ${message}`, ...args);
    }
  },
  trace: (message: string, ...args: any[]) => {
    if (Environment.isDev()) {
      console.trace(`[DEV-TRACE] ${message}`, ...args);
    }
  },
};

export const Var = {
  app: {
    name: "SenseFolks",
    contact: {
      email: "T@sensefolks.com",
      url: "https://sensefolks.com/support",
      twitter: "https://x.com/SenseFolks",
      reddit: "",
    },
    domain: "sensefolks.com",
    docs: {
      url: "https://sensefolks.com/docs",
    },
    branding: {
      logo: {
        logomark: {
          withoutBg:
            "https://res.cloudinary.com/dyygc6dx2/image/upload/v1757060437/Sensefolks_Logomark_Without_BG_mqx7at.svg",
          withBg:
            "https://res.cloudinary.com/dyygc6dx2/image/upload/v1757060437/Sensefolks_Logomark_With_BG_hiuual.svg",
        },
        logotype: {
          withBg:
            "https://res.cloudinary.com/dyygc6dx2/image/upload/v1757060437/Sensefolks_Logotype_With_BG_x4tv4z.svg",
          withoutBg:
            "https://res.cloudinary.com/dyygc6dx2/image/upload/v1757060437/Sensefolks_Logotype_Without_BG_g37eal.svg",
        },
      },
    },
    policy: {
      tos: {
        url: "https://sensefolks.com/policies/terms-of-service",
      },
      privacy: {
        url: "https://sensefolks.com/policies/privacy-policy",
      },
      cancellationAndRefund: {
        url: "https://sensefolks.com/policies/cancellation-and-refund",
      },
    },
    url: "https://sensefolks.com",
    owner: {
      name: "Projckt",
      website: { url: "https://projckt.com" },
      contact: {
        address: "Guwahati, Assam, India",
        email: "T@projckt.com",
      },
    },
  },
  api: {
    url: Environment.isDev()
      ? "http://localhost:4444"
      : "https://api.sensefolks.com",
    version: "v1",
    endpoint: {
      csrf: "/csrf-token",
      account: {
        details: "/account",
        auth: {
          login: "/auth/login",
          logout: "/auth/logout",
          signup: "/auth/signup",
          sessionCheck: "/auth/session-check",
          oauth: {
            google: "/auth/google",
            googleLink: '/auth/google/link',
          },
        },
        email: {
          sendVerificationCode: "/account/email/send-code",
          verify: "/account/email/verify",
        },
        password: {
          details: "/account/password",
          sendResetCode: "/account/password/send-code",
          reset: "/account/password/reset",
        },
      },
      billing: {
        plans: "/billing/plans",
        subscription: "/billing/subscription",
        usage: "/billing/usage",
        overCap: "/billing/usage/over-cap",
        overage: {
          quote: "/billing/overage/quote",
          purchase: "/billing/overage/purchase",
        },
        accountTier: "/billing/account-tier",
      },
      surveys: "/surveys",
      surveyEmbeds: "/survey-embeds",
      websites: "/websites",
    },
  },
  keys: {
    oauth: {
      google: {
        clientId:
          "178944295390-f88jbrvma5veepsgeq928qrure398cdj.apps.googleusercontent.com",
      },
    },
  },
};
